import React from 'react';
import { useParams } from 'react-router';
import { useQuery, useMutation } from '@apollo/client';
import { message, Spin, Typography } from 'antd';
import fp from 'lodash/fp';
import ApprovalRouteForm from './ApprovalRouteForm';
import {
  GET_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES,
  UPDATE_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES,
} from '../../../gql/projectCategories';

const getInitialValues = fp.pipe(
  fp.get('projectCategories'),
  fp.head,
  fp.get('approvalRouteTemplates'),
  fp.mapValues((value) => {
    return value ? value.id : void 0;
  })
);

const { Text } = Typography;

const TabApprovalRoutes = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(
    GET_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES,
    {
      variables: { ids: [id], state: 'ALL' },
    }
  );
  const [
    updateProjectCategoryApprovalRouteTemplates,
    { loading: mutationLoading },
  ] = useMutation(UPDATE_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES, {
    refetchQueries: [
      {
        query: GET_PROJECT_CATEGORY_APPROVAL_ROUTE_TEMPLATES,
        variables: { ids: [id], state: 'ALL' },
      },
    ],
    onCompleted: ({ updateProjectCategoryApprovalRouteTemplates }) => {
      message.success(
        `Report settings of ${updateProjectCategoryApprovalRouteTemplates.name} successfully edited`
      );
    },
    onError: (err) => {
      console.log(err);
    },
  });
  return (
    <Spin spinning={mutationLoading} tip="Updating...">
      <Text
        type="secondary"
        style={{ display: 'block', paddingBottom: '16px' }}
      >
        Approval route for virement, proposal revision, extension, withdrawal
      </Text>
      {!loading && (
        <ApprovalRouteForm
          onFinish={(input) => {
            console.log(input);
            updateProjectCategoryApprovalRouteTemplates({
              variables: {
                input: {
                  id,
                  approvalRouteTemplates: input,
                },
              },
            });
          }}
          initialValues={getInitialValues(data)}
        />
      )}
    </Spin>
  );
};

export default TabApprovalRoutes;
